import { Injectable } from '@angular/core';
import CryptoJS from 'crypto-js';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor(private cookieService:CookieService) { }

  setIsPendingPolicy(value:boolean){
    this.setValue('isPendingPolicy', value.toString());
  }

  getIsPendingPolicy(){
    let isPendingPolicy = this.getValue('isPendingPolicy');
    return isPendingPolicy === 'true' ? true : (isPendingPolicy === 'false' ? false : null);
  }

  setIsGracePayment(value:boolean){
    this.setValue('isGracePayment', value.toString());
  }

  getIsGracePayment(){
    let isGracePayment = this.getValue('isGracePayment');
    return isGracePayment === 'true' ? true : (isGracePayment === 'false' ? false : null);
  }

  setAccessToken(token:string){
    this.setEncryptedValue('accessToken', token);
  }

  getAccessToken(){
    return this.getEncryptedValue('accessToken');
  }

  removeAccessToken(){
    this.removeEncryptedValue('accessToken');
  }

  setUserInfo(userInfo){
    this.setEncryptedValue('userInfo', JSON.stringify(userInfo));
  }

  getUserInfo(){
    const userInfo = this.getEncryptedValue('userInfo');
    return userInfo ? JSON.parse(userInfo) : null;
  }


  setReceiptId(receiptId: string) {
    this.setEncryptedValue('receiptId', receiptId);
  }

  getReceiptId() {
    return this.getEncryptedValue('receiptId');
  }

  setSelectedPaymentMethod(paymentMethod: any) {
    this.setEncryptedValue('selectedPaymentMethod', JSON.stringify(paymentMethod));
  }

  getSelectedPaymentMethod() {
    const paymentMethod = this.getEncryptedValue('selectedPaymentMethod');
    return paymentMethod ? JSON.parse(paymentMethod) : null;
  }

  setPaymentAmount(paymentAmount: number) {
    this.setValue('paymentAmount', paymentAmount.toString());
  }

  getPaymentAmount() {
    let paymentAmount = this.getValue('paymentAmount');
    return paymentAmount ? parseFloat(paymentAmount) : null;
  }

  setPaymentFrequency(frequency: string) {
    this.setValue('paymentFrequency', frequency);
  }

  getPaymentFrequency() {
    return this.getValue('paymentFrequency');
  }


  //helpers
  private setEncryptedValue(key:string, value:string){
    this.removeEncryptedValue(key);
    const encryptedValue = CryptoJS.AES.encrypt(value, environment.encryptionKey).toString();
    this.cookieService.set(key, encryptedValue);
  }

  private removeEncryptedValue(key:string){
    this.cookieService.delete(key);
  }

  private getEncryptedValue(key:string){
    const encryptedValue = this.cookieService.get(key);
    if(encryptedValue){
      try {
        const bytes = CryptoJS.AES.decrypt(encryptedValue, environment.encryptionKey);
        return bytes.toString(CryptoJS.enc.Utf8);
      } catch(e){
        console.error('Error decrypting value for key:', key, e);
      }
    } 
    return null;
  }

  private setValue(key, value){
    localStorage.setItem(key, value);
  }

  private getValue(key){
    return localStorage.getItem(key);
  }

  private removeValue(key){
    localStorage.removeItem(key);
  }

  private clearAll(){
    localStorage.clear();
  }
}
